module.exports = __webpack_public_path__ + "static/logo-653a29e816fc98afcd2e4b01546ef5b9.png";